import React from 'react';
import { motion } from 'framer-motion';
import { cn } from './Section';
import { trackInitiateCheckout } from './metaPixel';
const CHECKOUT_URL = 'https://ecodemí.com/products/renacida-recupera-tu-bienestar-sin-anadir-mas-estres-a-tu-dia';
interface ButtonProps {
  children: React.ReactNode;
  variant?: 'primary' | 'secondary' | 'outline';
  className?: string;
  href?: string;
}
export function Button({
  children,
  variant = 'primary',
  className,
  href = CHECKOUT_URL
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center px-8 py-4 rounded-full font-medium transition-all duration-300 shadow-sm hover:shadow-md text-center focus:outline-none focus-visible:ring-2 focus-visible:ring-rose focus-visible:ring-offset-2';
  const variants = {
    primary: 'bg-rose text-white hover:bg-rose-dark',
    secondary: 'bg-sage text-white hover:bg-sage-light',
    outline: 'bg-transparent border-2 border-rose text-rose-dark hover:bg-rose/5'
  };
  return <motion.a href={href} onClick={() => trackInitiateCheckout()} whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} className={cn(baseStyles, variants[variant], className)} data-id="element-32">
      {children}
    </motion.a>;
}